import { Paper, styled } from "@mui/material";

export const GreyBox = styled(Paper)(
  ({ theme }) => `
  background-color: ${theme.palette.grey[100]};
  padding: ${theme.spacing(2)};
  height: 100%;
`
);
